import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentClassificationHeader from "./document-classification-header.vue";
import DocumentClassificationBody from "./document-classification-body.vue";
import DropzoneWrapper from "./dropzone-wrapper";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentClassificationCollapse",
  components: {
    DocumentClassificationHeader,
    DocumentClassificationBody,
    DropzoneWrapper
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    classification: {
      type: Object,
      required: true
    },
    documents: {
      type: Object,
      required: true
    },
    comments: {
      type: Object,
      required: true
    },
    sorting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      collapseVisible: false,
      showDropzone: false,
      disableChildren: false,
      files: []
    };
  },
  computed: {
    documentRequestId() {
      return this.classification.documentRequestId;
    },
    completedDocuments() {
      var _context;
      return _reduceInstanceProperty(_context = this.classification.documents).call(_context, (acc, documentId) => {
        const document = this.documents.byId[documentId];
        if (!document.isSample && document.requestStatus === "complete") return acc + 1;
        return acc;
      }, 0);
    },
    totalDocuments() {
      var _context2;
      return _reduceInstanceProperty(_context2 = this.classification.documents).call(_context2, (acc, documentId) => {
        const document = this.documents.byId[documentId];
        if (!document.isSample) return acc + 1;
        return acc;
      }, 0);
    },
    documentsForHeader() {
      var _context3, _context4;
      return _filterInstanceProperty(_context3 = _mapInstanceProperty(_context4 = this.classification.documents).call(_context4, id => this.documents.byId[id])).call(_context3, doc => !!doc);
    },
    documentsInClassification() {
      var _context5;
      return _reduceInstanceProperty(_context5 = this.classification.documents).call(_context5, (acc, documentId) => {
        acc.byId[documentId] = this.documents.byId[documentId];
        return acc;
      }, {
        byId: {}
      });
    }
  },
  methods: {
    handleDragEnter() {
      this.disableChildren = true;
      this.$nextTick(() => {
        this.showDropzone = true;
      });
    },
    handleDragLeave() {
      this.disableChildren = false;
      this.$nextTick(() => {
        this.showDropzone = false;
      });
    },
    handleAddFiles(files) {
      this.files = [...this.files, ...files];
      if (isEmpty(this.files)) this.showDropzone = false;
      this.disableChildren = false;
    },
    handleClearFiles() {
      this.files = [];
      this.showDropzone = false;
    }
  }
});